import React, { useContext, useEffect, useState } from 'react';
import { Button, makeStyles, Typography } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { Link, useLocation, useParams } from 'react-router-dom';
import { AuthContext } from '../../../auth';
import { blogErrorMessage, getManagedBlogPreview } from '../../../Apis/touzenBlogApi';
import { BlogLayout, BlogPostArticle } from './BlogPublicPage';

const useStyles = makeStyles((theme) => ({
  notice: { padding: theme.spacing(2), marginBottom: theme.spacing(3), border: `1px solid ${theme.palette.divider}`, borderRadius: 8 },
  text: { fontSize: '0.875rem', lineHeight: 1.7 },
  actions: { margin: theme.spacing(3, 0), display: 'flex', flexWrap: 'wrap', gap: theme.spacing(2) },
  back: {
    display: 'inline-flex', alignItems: 'center', gap: 4, minHeight: 44,
    fontSize: '0.875rem', color: '#6F6F6F', textDecoration: 'none',
    '&:hover, &:focus': { color: theme.palette.primary.main },
    '&:focus-visible': { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
  },
  icon: { fontSize: 14 },
}));

function PreviewContent({ postId, authenticated }) {
  const classes = useStyles();
  const location = useLocation();
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ loading: authenticated, data: null, error: null });
  useEffect(() => {
    // This tag belongs only to the private route; never remove a site's existing tag.
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex,nofollow,noarchive';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
  useEffect(() => {
    if (!authenticated) return undefined;
    let active = true;
    const controller = new AbortController();
    setState({ loading: true, data: null, error: null });
    getManagedBlogPreview(postId, controller.signal).then((data) => {
      if (active) setState({ loading: false, data, error: null });
    }).catch((error) => {
      if (active) setState({ loading: false, data: null, error });
    });
    return () => { active = false; controller.abort(); };
  }, [postId, authenticated, attempt]);
  return <>
    <div className={classes.notice} role="note" aria-label="保存済み記事のプレビュー">
      <Typography className={classes.text}>保存済み記事のプレビューです。公開状態は変わりません。</Typography>
      <Typography className={classes.text}>閲覧数・いいね・共有操作数には記録されません。</Typography>
      {state.data?.is_publication_blocked && <Typography className={classes.text}>管理者が公開を差し止めています。</Typography>}
    </div>
    {!authenticated && <Typography role="alert" className={classes.text}>プレビューするにはログインしてください。</Typography>}
    {authenticated && state.loading && <Typography role="status" className={classes.text}>記事を読み込んでいます。</Typography>}
    {authenticated && state.error && <div role="alert">
      <Typography className={classes.text}>{blogErrorMessage(state.error)}</Typography>
      <Button type="button" onClick={() => setAttempt((current) => current + 1)}>再読み込み</Button>
    </div>}
    {authenticated && state.data && <BlogPostArticle post={state.data.post} />}
    <div className={classes.actions}>
      <Link className={classes.back} to={`/blog/manage${location.search}`}><ArrowBackIcon className={classes.icon} aria-hidden="true" focusable="false" />ブログ管理へ</Link>
    </div>
  </>;
}

export default function BlogPreviewPage() {
  const auth = useContext(AuthContext) || {};
  const { postId } = useParams();
  const account = auth.user?.id || auth.user?.uuid || auth.user?.email || '';
  return <BlogLayout><PreviewContent key={`${postId}:${Boolean(auth.isAuth)}:${account}`} postId={postId} authenticated={Boolean(auth.isAuth)} /></BlogLayout>;
}
